module.exports = __webpack_public_path__ + "static/Glober_Regular-6fdcea77895f542eaf97116d61ee3d31.svg";